import { useSelector } from 'react-redux';
import { thoughtspot } from 'config';
import { initialiseThoughtspot } from 'utils/thoughtspotInit';
import { cancelFunctions } from 'utils/cancelFunctions';
import { Store } from 'components/common/types/Store.types';
import LiveboardVisuals from 'components/common/LiveboardVisuals';
import {
  filterByMarket,
  thoughtspotLiveboardStyles,
  labsReportVisibleActions,
  TABS_STYLES,
} from '../LabsReportDropdown/utils';

const RevenueInsights: React.FC = () => {
  const { localeCode, marketId } = useSelector((state: Store) => state.publisher.configuration);

  initialiseThoughtspot(localeCode, cancelFunctions);

  return (
    <div className={TABS_STYLES}>
      <LiveboardVisuals
        liveboardId={thoughtspot.revenueInsightsLiveboardId}
        customizations={thoughtspotLiveboardStyles}
        visibleActions={labsReportVisibleActions}
        filterByOptions={[filterByMarket(marketId)]}
      />
    </div>
  );
};

export default RevenueInsights;
